import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';

export default function NewsroomScreenRunVideoRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.NewsroomScreenRunVideo', {
		url: '/newsroom/video/:code',
		controllerAs: 'vm',
		controller: NewsroomScreenRunVideoCtrl,
		templateUrl: '/ng/hub/Newsroom/Screen/Run/Video/NewsroomScreenRunVideoCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Newsroom/Screen/Run/Video/NewsroomScreenRunVideoCtrl.css'),
			$title: () => 'Newsroom :: Videos',
			newsroom: ApiResourcify.public('/newsrooms/screens/run/:code'),
		},
	});
}

class NewsroomScreenRunVideoCtrl {
	constructor(newsroom, Pubnub, modal, ErrorScreen) {
		'ngInject';
		this.newsroom = newsroom;
		this.videos = newsroom.videos;
		if (this.videos.length < 1) {
			ErrorScreen.show({
				class: 'not-allowed',
				title: 'Not enough content',
				message: 'This newsroom screen needs more videos before it can be displayed.',
				actionText: 'Home',
				actionUrl: '/',
			});
			return;
		}
		this.colors = _.pluck(this.newsroom.colors, 'bgColor');
		Pubnub.awaitReload('newsroom_' + newsroom.code);
		if (this.newsroom.options.elements.fullscreen !== '0') {
			modal.fullscreen({
				text: 'Go fullscreen?',
				heading: 'Newsroom Mode',
				timeoutMs: 8000,
			});
		}
	}
}
